/* Mejora progresiva: enlaces y acordeones funcionan también sin este archivo. */
(() => {
  if (window.jherrNavigationInstalled) return;
  window.jherrNavigationInstalled = true;
  const desktopSelector = 'details[data-jh-menu="desktop"]';
  const mobileSelector = 'details[data-jh-menu="mobile"]';
  const detailsSelector = `${desktopSelector}, ${mobileSelector}, .jh-mobile-group`;
  const hoverTimers = new WeakMap();
  const scrollAreas = new WeakSet();

  function sync(details) {
    const summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', String(details.open));
  }
  function setOpen(details, open) {
    clearTimeout(hoverTimers.get(details));
    details.open = open;
    sync(details);
    // Cada acordeón móvil conserva su estado al explorar otras categorías.
    if (!open || !details.matches(desktopSelector)) return;
    const peers = document.querySelectorAll(`${desktopSelector}[open]`);
    peers.forEach(peer => { if (peer !== details) setOpen(peer, false); });
  }
  function closeDesktop(restoreFocus = false) {
    document.querySelectorAll(`${desktopSelector}[open]`).forEach(details => {
      const summary = details.querySelector(':scope > summary');
      setOpen(details, false);
      if (restoreFocus && summary) summary.focus();
    });
  }
  function closeNavForOverlay() {
    const drawer = document.querySelector('#NavDrawer.jh-menu-drawer');
    const controller = window.theme && window.theme.NavDrawer;
    if (!drawer || !controller) return false;
    const wasOpen = controller.isOpen;
    // El nuevo modal o carrito conserva el foco durante el cierre de navegación.
    if (controller.activeSource) controller.activeSource.setAttribute('aria-expanded', 'false');
    controller.activeSource = null;
    if (wasOpen) controller.close();
    return wasOpen;
  }
  function init(scope = document) {
    scope.querySelectorAll(detailsSelector).forEach(sync);
    scope.querySelectorAll('#NavDrawer.jh-menu-drawer .drawer__scrollable').forEach(scrollable => {
      if (scrollAreas.has(scrollable)) return;
      // El gesto desplaza el menú sin alcanzar los bloqueos táctiles de la página o las apps.
      scrollable.addEventListener('touchmove', event => event.stopPropagation(), { passive: true });
      scrollAreas.add(scrollable);
    });
  }

  document.addEventListener('toggle', event => {
    const details = event.target;
    if (details instanceof HTMLDetailsElement && details.matches(detailsSelector)) setOpen(details, details.open);
  }, true);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const summary = event.target.closest('summary');
    const details = summary && summary.parentElement;
    if (details instanceof HTMLDetailsElement && details.matches(detailsSelector)) {
      event.preventDefault();
      setOpen(details, !details.open);
    }
    if (!event.target.closest(desktopSelector)) closeDesktop();
    if (event.target.closest('.js-drawer-open-cart, .js-drawer-open-nav, .js-search-header')) closeDesktop();
  }, true);
  document.addEventListener('focusin', event => {
    document.querySelectorAll(`${desktopSelector}[open]`).forEach(details => {
      if (!details.contains(event.target)) setOpen(details, false);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeDesktop(true);
  });

  // El conjunto visible cambia al expandir los acordeones; el foco sigue dentro del drawer.
  document.addEventListener('keydown', event => {
    if (event.key !== 'Tab' || !(event.target instanceof Element)) return;
    const drawer = event.target.closest('#NavDrawer.jh-menu-drawer.drawer--is-open');
    if (!drawer) return;
    const focusable = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex="0"]'))
      .filter(element => element.getClientRects().length > 0 && !element.closest('[inert]'));
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first) return;
    if (event.shiftKey && (document.activeElement === first || document.activeElement === drawer)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === drawer)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      first.focus();
    }
  }, true);
  // El buscador del menú del celular abre el buscador inteligente (sugerencias, códigos, precios).
  // El campo del menú queda de solo lectura para que el teclado se abra en el buscador real.
  const menuSearchSelector = '#NavDrawer .jh-mobile-search input[type="search"]';
  function menuSearchInput(event) {
    return event.target instanceof Element ? event.target.closest(menuSearchSelector) : null;
  }
  function openSmartSearch(input) {
    const query = input.value;
    input.blur();
    closeNavForOverlay();
    window.jherrOpenSearch(query);
  }
  document.addEventListener('pointerdown', event => {
    const input = menuSearchInput(event);
    if (input && typeof window.jherrOpenSearch === 'function') input.readOnly = true;
  }, true);
  document.addEventListener('click', event => {
    const input = menuSearchInput(event);
    if (!input || typeof window.jherrOpenSearch !== 'function') return;
    event.preventDefault();
    openSmartSearch(input);
  }, true);
  document.addEventListener('keydown', event => {
    const input = menuSearchInput(event);
    if (!input || typeof window.jherrOpenSearch !== 'function' || event.key === 'Tab') return;
    event.preventDefault();
    if (event.key && event.key.length === 1) input.value += event.key;
    openSmartSearch(input);
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target instanceof Element && event.target.closest('#NavDrawer .jh-mobile-search');
    if (!form || typeof window.jherrOpenSearch !== 'function') return;
    event.preventDefault();
    const input = form.querySelector('input[type="search"]');
    closeNavForOverlay();
    window.jherrOpenSearch(input ? input.value : '');
  }, true);

  document.addEventListener('drawerOpen', () => closeDesktop());
  document.addEventListener('modalOpen', () => {
    closeDesktop();
    closeNavForOverlay();
  });
  document.addEventListener('drawerOpen.CartDrawer', () => {
    closeDesktop();
    const closedNav = closeNavForOverlay();
    const cart = document.getElementById('CartDrawer');
    if (closedNav && cart && cart.classList.contains('drawer--is-open')) {
      document.documentElement.classList.add('js-drawer-open');
      if (window.theme && window.theme.a11y) window.theme.a11y.trapFocus({ container: cart, namespace: 'drawer_focus' });
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.addEventListener('resize', () => { if (window.innerWidth < 1200) closeDesktop(); });

  // Apertura opcional con el puntero, respetando el ajuste del encabezado.
  document.addEventListener('pointerover', event => {
    if (!(event.target instanceof Element) || !window.matchMedia('(hover: hover) and (min-width: 1200px)').matches) return;
    const details = event.target.closest(`${desktopSelector}[data-jh-hover="true"]`);
    if (!details) return;
    clearTimeout(hoverTimers.get(details));
    if (!details.contains(event.relatedTarget)) setOpen(details, true);
  });
  document.addEventListener('pointerout', event => {
    if (!(event.target instanceof Element)) return;
    const details = event.target.closest(`${desktopSelector}[data-jh-hover="true"]`);
    if (!details || details.contains(event.relatedTarget)) return;
    hoverTimers.set(details, setTimeout(() => {
      if (!details.contains(document.activeElement)) setOpen(details, false);
    }, 170));
  });
  // Menú de computadora: al pasar por un enlace, la foto grande muestra esa colección.
  function previewTile(link) {
    const panel = link.closest('.jh-panel');
    const tile = panel && panel.querySelector('[data-jh-preview]');
    if (!tile) return;
    const src = link.dataset.jhImg || tile.dataset.defaultImg;
    showInTile(tile, {
      href: link.getAttribute('href'),
      title: link.dataset.jhTitle || link.textContent.trim(),
      count: link.dataset.jhCount || '',
      img: src,
      fit: link.dataset.jhImg ? (link.dataset.jhFit || 'cover') : (tile.dataset.defaultFit || 'cover')
    });
    panel.querySelectorAll('.jh-menu-link.is-previewing').forEach(el => el.classList.remove('is-previewing'));
    link.classList.add('is-previewing');
  }
  function showInTile(tile, data) {
    tile.setAttribute('href', data.href);
    const title = tile.querySelector('[data-jh-preview-title]');
    const count = tile.querySelector('[data-jh-preview-count]');
    if (title) title.textContent = data.title;
    if (count && data.count) count.textContent = data.count;
    const media = tile.querySelector('.jh-mega-tile__media');
    if (!media || !data.img) return;
    let img = media.querySelector('img');
    if (img && img.getAttribute('src') === data.img) return;
    if (!img) {
      img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      media.appendChild(img);
    }
    tile.classList.add('is-swapping');
    const next = new Image();
    next.onload = next.onerror = () => {
      if (tile.dataset.jhPending !== data.img) return;
      img.removeAttribute('srcset');
      img.src = data.img;
      img.alt = data.title;
      media.dataset.fit = data.fit;
      requestAnimationFrame(() => tile.classList.remove('is-swapping'));
    };
    tile.dataset.jhPending = data.img;
    next.src = data.img;
  }
  function resetTile(panel) {
    const tile = panel && panel.querySelector('[data-jh-preview]');
    if (!tile) return;
    panel.querySelectorAll('.jh-menu-link.is-previewing').forEach(el => el.classList.remove('is-previewing'));
    showInTile(tile, {
      href: tile.dataset.defaultHref,
      title: tile.dataset.defaultTitle,
      count: tile.dataset.defaultCount,
      img: tile.dataset.defaultImg,
      fit: tile.dataset.defaultFit || 'cover'
    });
  }
  const previewTimers = new WeakMap();
  document.addEventListener('pointerover', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.jh-panel .jh-menu-link[data-jh-title]');
    if (!link) return;
    const panel = link.closest('.jh-panel');
    clearTimeout(previewTimers.get(panel));
    // Una pequeña pausa evita cambiar la foto cuando el mouse solo cruza la lista
    previewTimers.set(panel, setTimeout(() => previewTile(link), 70));
  });
  document.addEventListener('focusin', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.jh-panel .jh-menu-link[data-jh-title]');
    if (link) previewTile(link);
  });
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (details instanceof HTMLDetailsElement && details.matches(desktopSelector) && !details.open) {
      resetTile(details.querySelector('.jh-panel'));
    }
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
